import React from "react";
import { useState } from "react";
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow,
  CInvalidFeedback,
  CSpinner,
  CFormGroup,
  CInputRadio,
  CLabel,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";

import banner from "../../assets/images/cgmfpfed_logo1-1.gif";

import { apiCall, apiCallResponse, apiCallSP } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import { AlertResponse } from "src/_constants/alert.type";
import ToastMessage from "src/_components/ToastMessage";
const LoginPage = (props) => {
  const { login, authenticated } = Auth();
  if (authenticated) {
    props.history.push("/");
  }

  const [otp, setOtp] = useState();
  const [isLogin, setIsLogin] = useState(false);
  const [mobile, setMobile] = useState();
  const [userId, setUserId] = useState();
  const [validate, setvalidate] = useState(true);
  const [status, setstatus] = useState(false);
  const [loadding, setLoadding] = useState(false);
  const [toasts, setToasts] = useState(AlertResponse);

  const [isMultipleAccount, setIsMultipleAccount] = useState(false);
  const [UserData, setUserData] = useState([]);
  const [loadingIndex, setLoadingIndex] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);

  const PreRequestOtp = async (event) => {
    setLoadding(true);
    const header = new Headers();
    header.append("Content-Type", "application/json");

    // Assuming 'mobile' is defined somewhere in your component's state or props
    const data = JSON.stringify({
      mobile: mobile,
    });

    try {
      await apiCallSP(
        "Account/PreRequestOTP", // Endpoint URL
        "POST", // HTTP method
        header, // Headers
        data // Request body
      ).then((res) => {
        console.log("Response:", res);
        if (res.success) {
          // Assuming these functions update state variables in your React component
          setUserData(res.data); // Update user data state
          if (res.data.length === 1) {
            //setIsLogin(true);
            setUserId(res.data[0].userId);
            handleSubmit(event, res.data[0].userId);
          } else {
            setIsMultipleAccount(true);
            setvalidate(true);
            setLoadding(false);
          }
        } else {
          setvalidate(false);
          setLoadding(false);
          //addToastError(setToasts, res.message);

          console.error("Failed to fetch data:", res.status);
          // Handle error scenarios
        }
      });
    } catch (error) {
      console.error("Error occurred:", error);
      // Handle exceptions
    }
  };

  async function handleSubmit(event, userId) {
    event.preventDefault();
    setLoadding(true);
    const header = new Headers();
    header.append("Content-Type", "application/json");
    await apiCallResponse(
      `Account/RequestOTP`,
      "POST",
      header,
      JSON.stringify({
        mobile: mobile,
        userid: userId,
      })
    )
      .then((res) => {
        console.log(res);
        if (res.success) {
          setIsLogin(true);
          setvalidate(true);
          setLoadding(false);
        } else {
          setvalidate(false);
          setLoadding(false);
          //addToastError(setToasts, res.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const verifyHandleSubmit = async (event) => {
    event.preventDefault();

    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      `Account/VerifyOTP`,
      "POST",
      header,
      JSON.stringify({
        mobile: mobile,
        otp: otp,
        userId: userId,
      })
    );
    if (response.status === 200) {
      const jsonobj = await response.json();

      if (jsonobj.subRoleName === "CGMF") {
        login(() => {
          props.history.push("");
          return {
            userId: jsonobj.id,
            username: jsonobj.username,
            role:
              jsonobj.subRoleName !== ""
                ? jsonobj.subRoleName
                : jsonobj.roleName,
            jwt: jsonobj.accessToken,
            district: " ",
            isViewOnly: !!jsonobj.isViewOnly,
            roleMasterId: jsonobj.roleMasterId,
          };
        });
      } else if (jsonobj.subRoleName === "CFO") {
        login(() => {
          props.history.push("");
          return {
            userId: jsonobj.id,
            username: jsonobj.username,
            role:
              jsonobj.subRoleName !== ""
                ? jsonobj.subRoleName
                : jsonobj.roleName,
            jwt: jsonobj.accessToken,
            district: jsonobj.circleId,
            isViewOnly: !!jsonobj.isViewOnly,
            roleMasterId: 0,
          };
        });
      } else if (jsonobj.subRoleName === "DFO") {
        login(() => {
          props.history.push("");
          return {
            userId: jsonobj.id,
            username: jsonobj.username,
            role:
              jsonobj.subRoleName !== ""
                ? jsonobj.subRoleName
                : jsonobj.roleName,
            jwt: jsonobj.accessToken,
            district: jsonobj.districtId,
            isViewOnly: !!jsonobj.isViewOnly,
            roleMasterId: 0,
          };
        });
      } else {
        login(() => {
          props.history.push("");
          return {
            userId: jsonobj.id,
            username: jsonobj.username,
            role: jsonobj.roleName,
            jwt: jsonobj.accessToken,
            district: jsonobj.id,
            isViewOnly: !!jsonobj.isViewOnly,
            roleMasterId: 0,
          };
        });
      }

      setvalidate(true);
    } else {
      setvalidate(false);
    }
  };

  const CompanyClick = (e, userId, index) => {
    setLoadingIndex(index);
    setUserId(userId);
    setSelectedOption(userId);
    //alert("userId:  " + userId);
    handleSubmit(e, userId);
  };

  // const CompanyProfileResponsiveForm = ({
  //   mobile,
  //   UserData,
  //   selectedOption,
  //   CompanyClick,
  //   loadingIndex,
  // }) => {
  //   return (
  //     <CForm className="has-validation">
  //       <h3 className="text-center">Post Bid Management System</h3>
  //       <p className="text-muted text-center">Login Page</p>

  //       <CInputGroup className="mb-3">
  //         <CInputGroupPrepend>
  //           <CInputGroupText>
  //             <CIcon name="cil-user" />
  //           </CInputGroupText>
  //         </CInputGroupPrepend>
  //         <CInput
  //           type="text"
  //           placeholder="MobileNo"
  //           value={mobile}
  //           id="validationCustom01"
  //           required
  //           disabled
  //         />
  //       </CInputGroup>

  //       <div className="mb-2">
  //         <div className="viewTable p-2">
  //           <CRow>
  //             <CCol xs={12}>
  //               <p>Please select the company that you want to log with.</p>
  //             </CCol>

  //             {UserData?.map((item, index) => (
  //               <CCol xs={12} key={`cf_${index}`}>
  //                 <CFormGroup
  //                   variant="checkbox"
  //                   onClick={(e) =>
  //                     selectedOption === null &&
  //                     CompanyClick(e, item.userId, index)
  //                   }
  //                   className="centered-radio-group"
  //                 >
  //                   <div
  //                     className={`centered-radio-container ${
  //                       selectedOption !== null ? "disabled" : ""
  //                     }`}
  //                   >
  //                     <CInputRadio
  //                       key={`ci_${index}`}
  //                       className="form-check-input"
  //                       id={`radio${index}`}
  //                       name="companySelection"
  //                       value={item.userId}
  //                       checked={selectedOption === item.userId}
  //                       disabled={
  //                         selectedOption !== null &&
  //                         selectedOption !== item.userId
  //                       }
  //                     />
  //                     <CLabel
  //                       key={`cl_${index}`}
  //                       variant="checkbox"
  //                       htmlFor={`radio${index}`}
  //                       className="centered-radio-label"
  //                       disabled={selectedOption !== null}
  //                     >
  //                       <div>
  //                         <strong>{item.companyName}</strong> (
  //                         <strong>{item.emailId}</strong>)
  //                       </div>
  //                     </CLabel>
  //                     {loadingIndex === index && (
  //                       <div>
  //                         <CSpinner
  //                           as="span"
  //                           size="sm"
  //                           aria-hidden="true"
  //                           className="ml-2"
  //                         />
  //                       </div>
  //                     )}
  //                   </div>
  //                 </CFormGroup>
  //               </CCol>
  //             ))}
  //           </CRow>
  //         </div>
  //       </div>
  //     </CForm>
  //   );
  // };
  return (
    <div className="c-app c-default-layout flex-row">
      <ToastMessage toasts={toasts} setToasts={setToasts} />
      <CContainer>
        <CRow className="justify-content-center mt-5">
          <img src={banner} className="img-fluid mb-5 mt-5" alt="" />
        </CRow>
        <CRow className="justify-content-center mt-5">
          {/* <CCol xl="5" lg="6" md="8" sm="10" className={"col-10"}> */}

          {!isLogin ? (
            !isMultipleAccount ? (
              <CCol md="4">
                <CCardGroup>
                  <CCard className="p-4">
                    <CCardBody>
                      <CForm
                        className="has-validation"
                        onSubmit={PreRequestOtp}
                      >
                        <h3 className="text-center">
                          Post Bid Management System
                        </h3>
                        {/* <h1>Login</h1> */}
                        <p className="text-muted text-center">Login Page</p>
                        <CInputGroup className="mb-3">
                          <CInputGroupPrepend>
                            <CInputGroupText>
                              <CIcon name="cil-user" />
                            </CInputGroupText>
                          </CInputGroupPrepend>
                          <CInput
                            type="text"
                            placeholder="MobileNo"
                            value={mobile}
                            onChange={(e) => {
                              setMobile(
                                e.target.value.trim().replace(/\s+/g, "")
                              );
                            }}
                            id="validationCustom01"
                            invalid={
                              mobile === "" || validate === false ? true : false
                            }
                            required
                          />
                          <CInvalidFeedback className="validationCustom01">
                            Please enter valid Mobile Number
                          </CInvalidFeedback>
                        </CInputGroup>
                        <CRow>
                          <CCol xl={12}>
                            <input
                              placeholder=""
                              type="checkbox"
                              checked={status ? status : false}
                              onChange={() => setstatus(!status)}
                            />{" "}
                            &nbsp;{" "}
                            {
                              "User is authorized to sign & access the system on behalf of the organization"
                            }
                          </CCol>
                        </CRow>
                        <CRow>
                          <CCol xs="12" className="text-center mt-3">
                            <CButton
                              type="button"
                              color="success"
                              className="px-4"
                              disabled={!status || loadding}
                              onClick={PreRequestOtp}
                            >
                              {loadding ? (
                                <>
                                  <CSpinner
                                    as="span"
                                    size="sm"
                                    aria-hidden="true"
                                  />{" "}
                                  &nbsp; Get OTP
                                </>
                              ) : (
                                <> Get OTP </>
                              )}
                            </CButton>
                          </CCol>
                        </CRow>
                      </CForm>
                    </CCardBody>
                  </CCard>
                </CCardGroup>
              </CCol>
            ) : (
              <CCol
                className={
                  "col-xxl-4 col-xl-4 col-lg-6 col-md-8 col-sm-10 col-12"
                }
              >
                <CCardGroup>
                  <CCard className="p-4">
                    <CCardBody>
                      <CForm className="has-validation">
                        <h3 className="text-center">
                          Post Bid Management System
                        </h3>
                        <p className="text-muted text-center">Login Page</p>

                        <CInputGroup className="mb-3">
                          <CInputGroupPrepend>
                            <CInputGroupText>
                              <CIcon name="cil-user" />
                            </CInputGroupText>
                          </CInputGroupPrepend>
                          <CInput
                            type="text"
                            placeholder="MobileNo"
                            value={mobile}
                            id="validationCustom01"
                            required
                            disabled
                          />
                        </CInputGroup>

                        <div className="mb-2">
                          <div className="viewTable p-2">
                            <CRow>
                              <CCol xs={12}>
                                <p>
                                  Please select the company that you want to log
                                  with.
                                </p>
                              </CCol>

                              {UserData?.map((item, index) => (
                                // <CCol xs={12} key={`cf_${index}`}>
                                <CFormGroup
                                  variant="checkbox"
                                  onClick={(e) =>
                                    selectedOption === null &&
                                    CompanyClick(e, item.userId, index)
                                  }
                                  className="centered-radio-group"
                                >
                                  <div
                                    className={`centered-radio-container ${
                                      selectedOption !== null ? "disabled" : ""
                                    }`}
                                  >
                                    <CInputRadio
                                      key={`ci_${index}`}
                                      className="form-check-input"
                                      id={`radio${index}`}
                                      name="companySelection"
                                      value={item.userId}
                                      checked={selectedOption === item.userId}
                                      disabled={
                                        selectedOption !== null &&
                                        selectedOption !== item.userId
                                      }
                                    />
                                    <CLabel
                                      key={`cl_${index}`}
                                      variant="checkbox"
                                      htmlFor={`radio${index}`}
                                      className="centered-radio-label"
                                      disabled={selectedOption !== null}
                                    >
                                      <div>
                                        <strong>{item.companyName}</strong> (
                                        <strong>{item.emailId}</strong>)
                                      </div>
                                    </CLabel>
                                    {loadingIndex === index && (
                                      <div>
                                        <CSpinner
                                          as="span"
                                          size="sm"
                                          aria-hidden="true"
                                          className="ml-2"
                                        />
                                      </div>
                                    )}
                                  </div>
                                </CFormGroup>
                                // </CCol>
                              ))}
                            </CRow>
                          </div>
                        </div>
                      </CForm>
                    </CCardBody>
                  </CCard>
                </CCardGroup>
              </CCol>
              // <CompanyProfileResponsiveForm
              //   mobile={mobile}
              //   UserData={UserData}
              //   selectedOption={UserData}
              //   CompanyClick={CompanyClick}
              //   loadingIndex={loadingIndex}
              // />
              // <CForm className="has-validation">
              //   <h3 style={{ textAlign: "center" }}>
              //     Post Bid Management System
              //   </h3>
              //   {/* <h1>Login</h1> */}
              //   <p
              //     className="text-muted"
              //     style={{ textAlign: "center" }}
              //   >
              //     Login Page
              //   </p>
              //   <CInputGroup className="mb-3">
              //     <CInputGroupPrepend>
              //       <CInputGroupText>
              //         <CIcon name="cil-user" />
              //       </CInputGroupText>
              //     </CInputGroupPrepend>
              //     <CInput
              //       type="text"
              //       placeholder="MobileNo"
              //       value={mobile}
              //       id="validationCustom01"
              //       required
              //       disabled
              //     />
              //   </CInputGroup>
              //   <div className="mb-2">
              //     <div className="viewTable pl-1 pr-1">
              //       <CRow className="pl-2 pr-1">
              //         <CCol xl={12}>
              //           Please select the company that you want to log
              //           with it.
              //         </CCol>

              //         {UserData?.map((item, index) => (
              //           <CFormGroup
              //             variant="checkbox"
              //             onClick={(e) =>
              //               selectedOption === null &&
              //               CompanyClick(e, item.userId, index)
              //             }
              //             //disabled={loadding}
              //             key={`cf_${index}`}
              //             className="centered-radio-group"
              //           >
              //             <div
              //               className={`centered-radio-container  ${
              //                 selectedOption !== null ? "disabled" : ""
              //               }`}
              //             >
              //               <CInputRadio
              //                 key={`ci_${index}`}
              //                 className="form-check-input"
              //                 id={`radio${index}`}
              //                 name={"companySelection"}
              //                 value={item.userId}
              //                 checked={selectedOption === item.userId}
              //                 disabled={
              //                   selectedOption !== null &&
              //                   selectedOption !== item.userId
              //                 }
              //               />
              //               <CLabel
              //                 key={`cl_${index}`}
              //                 variant="checkbox"
              //                 htmlFor={`radio${index}`}
              //                 className="centered-radio-label"
              //                 disabled={selectedOption !== null}
              //               >
              //                 <div>
              //                   <strong>{item.companyName}</strong> (
              //                   <strong>{item.emailId}</strong>)
              //                 </div>
              //               </CLabel>
              //               {loadingIndex === index && (
              //                 <div>
              //                   <CSpinner
              //                     as="span"
              //                     size="sm"
              //                     aria-hidden="true"
              //                     style={{
              //                       // float: "left",
              //                       marginTop: "-1.95rem",
              //                       marginLeft: "0.175rem",
              //                     }}
              //                   />
              //                 </div>
              //               )}
              //             </div>
              //           </CFormGroup>
              //         ))}

              //         {/* {UserData?.map((item, index) => (
              //           <CFormGroup
              //             variant="checkbox"
              //             onClick={(e) =>
              //               CompanyClick(e, item.userId, index)
              //             }
              //             disabled={loadding}
              //           >
              //             <CInputRadio
              //               className="form-check-input"
              //               id={`radio${index}`}
              //               name={`radio${index}`}
              //               value={item.userId}
              //             />
              //             <CLabel
              //               variant="checkbox"
              //               htmlFor={`radio${index}`}
              //             >
              //               <div>
              //                 <strong>{item.companyName}</strong> (
              //                 <strong>{item.emailId}</strong>)
              //               </div>
              //             </CLabel>
              //           </CFormGroup>
              //         ))}
              //         {UserData?.map((item, index) => (
              //           <CCol xl={12}>
              //             <CCard
              //               disabled={loadding}
              //               color="success"
              //               className={`text-white text-center mb-2 btn-card ${
              //                 loadding ? "disabled-card" : ""
              //               } ${
              //                 loadingIndex !== ""
              //                   ? loadingIndex !== index
              //                     ? "deactive"
              //                     : "active"
              //                   : "active"
              //               }`}
              //               onClick={(e) =>
              //                 CompanyClick(e, item.userId, index)
              //               }
              //               key={"Update_" + index}
              //             >
              //               <CCardBody>
              //                 {loadingIndex === index && (
              //                   <CSpinner
              //                     as="span"
              //                     size="sm"
              //                     aria-hidden="true"
              //                     style={{
              //                       // float: "left",
              //                       marginTop: "-1.95rem",
              //                       marginLeft: "0.175rem",
              //                     }}
              //                   />
              //                 )}
              //                 <div>
              //                   Company :{" "}
              //                   <strong>{item.companyName}</strong>
              //                 </div>
              //                 <div>
              //                   E-mail Id :{" "}
              //                   <strong>{item.emailId}</strong>
              //                 </div>
              //               </CCardBody>
              //             </CCard>
              //           </CCol>
              //         ))} */}
              //       </CRow>
              //     </div>
              //   </div>
              // </CForm>
            )
          ) : (
            <CCol md="4">
              <CCardGroup>
                <CCard className="p-4">
                  <CCardBody>
                    <CForm
                      className="has-validation"
                      onSubmit={verifyHandleSubmit}
                    >
                      <h1>Verify OTP</h1>
                      <CInputGroup className="mb-3 mt-4">
                        <CInput
                          type="text"
                          placeholder="otp"
                          value={otp}
                          onChange={(e) => {
                            setOtp(e.target.value);

                            setvalidate(true);
                          }}
                          id="validationCustom01"
                          invalid={validate === false ? true : false}
                          required
                        />
                        <CInvalidFeedback className="validationCustom01">
                          Please enter valid OTP
                        </CInvalidFeedback>
                      </CInputGroup>

                      <CRow>
                        <CCol xs="12" className="text-center">
                          <CButton
                            type="submit"
                            color="success"
                            className="px-4"
                          >
                            Verify OTP
                          </CButton>
                        </CCol>
                      </CRow>
                    </CForm>
                  </CCardBody>
                </CCard>
              </CCardGroup>
            </CCol>
          )}
        </CRow>
      </CContainer>
    </div>
  );
};

export default LoginPage;
